// Cross-tab notification for the product SSO hand-off. The mint happens in the product tab
// (/mint-oauth-redirect), so the tab that started the flow never sees the provisioning result and
// would otherwise keep showing a stale contract list / stale useMe.productAccounts.
const CHANNEL_NAME = "irohana-product-handoff";

export type TProductHandoffMessage = {
  organizationId: string;
  productCode: string;
};

/** Announces a completed hand-off to every other tab on this origin. No-op where BroadcastChannel is unavailable. */
export const notifyProductHandoff = (message: TProductHandoffMessage): void => {
  if (typeof BroadcastChannel === "undefined") return;
  try {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage(message);
    channel.close();
  } catch {
    // Best-effort only: a failed notification just means the opener refreshes a bit later.
  }
};

/** Subscribes to hand-off announcements. Returns an unsubscribe function. */
export const subscribeProductHandoff = (listener: (message: TProductHandoffMessage) => void): (() => void) => {
  if (typeof BroadcastChannel === "undefined") return () => undefined;

  let channel: BroadcastChannel;
  try {
    channel = new BroadcastChannel(CHANNEL_NAME);
  } catch {
    return () => undefined;
  }

  const handleMessage = (event: MessageEvent<TProductHandoffMessage>) => listener(event.data);
  channel.addEventListener("message", handleMessage);

  return () => {
    channel.removeEventListener("message", handleMessage);
    channel.close();
  };
};
